import { createFileRoute, type SearchSchemaInput } from '@tanstack/react-router';

import {
  postListParams,
  postListSearchSchema,
  PostsPage,
  socialPostListQueryOptions,
} from '@/features/social';

export const Route = createFileRoute('/_authed/_active/s/$storeId/social/pinterest/posts/')({
  // Typed as the raw input so links into the list need no search.
  validateSearch: (search: Record<string, unknown> & SearchSchemaInput) =>
    postListSearchSchema.parse(search),
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...socialPostListQueryOptions(params.storeId, postListParams(deps, 'pinterest')),
        staleTime: 'static',
      })
      .catch(() => undefined);
    // A filter or page change on the list itself must not wait for the fetch, or a second pick
    // in the filter picker would build on stale filters (see the orders route).
    if (cause !== 'stay') await prefetch;
  },
  component: PostsPage,
});
